import { Typography, styled } from '@mui/material';

import { regularTextColor } from 'assets/styles/_palette';

export const StreamingText = styled(Typography)({
	display: 'inline-block',
	position: 'relative',
	color: regularTextColor,
});
